import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconLicensePlate = createIcon({
  displayName: 'IconLicensePlate',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M23 19H1V5H23V7H3V17H21V9H23V19ZM7 12C7 12.5523 6.55228 13 6 13C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12ZM19 12C19 12.5523 18.5523 13 18 13C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11C18.5523 11 19 11.4477 19 12ZM9 11H15V13H9V11Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
